import React                                    from 'react';
import { withRouter }                           from 'react-router-dom';
import { connect }                              from 'react-redux';

import { obfuscatePhoneNumber }                 from '../helpers/stringUtils';
const classNames = require('classnames');

const InboxPlaceholder = ({ ownProps, placeholder, translate, history }) => {

    const { placeholderInfo, placeholderRoute } = placeholder;
    const currentRoute = ownProps.location.pathname;

    const handleChatStarter = () => {
        history.push(placeholderRoute);
    };

    const renderPlaceholder = () => {

        const { name, phone_number } = placeholderInfo;

        function toTitleCase(str) {
            return str.replace(/\s\s+/g, ' ').replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }

        if (name) {
            return toTitleCase(name);
        }

        if (phone_number) {
            return obfuscatePhoneNumber(phone_number);
        }

        return translate('contacts_noname');
    };

    const formatRoute = route => {
        const match = route.split('?');
        if (match && match.length > 0) {
            return match[0];
        }
        return;
    };

    const placeholderClass = classNames({
        conversation__placeholder: true,
        conversation__placeholder__active: formatRoute(placeholderRoute) === currentRoute ? true : false,
    });

    return (
        <div className={placeholderClass} onClick={handleChatStarter}>
            <div className="conversation__placeholder__recipientName">
                {renderPlaceholder()}
            </div>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        placeholder: state.conversationsListStore.placeholder,
        ownProps
    };
};

export default withRouter(connect(mapStateToProps)(InboxPlaceholder));



// WEBPACK FOOTER //
// ./src/components/InboxPlaceholder.tsx